import type { BlokProps } from "@trydig/storyblok";
import { Container } from "@/components/ui/Container";
import {
	MAPBOX_INITIAL_CENTER,
	MAPBOX_INITIAL_ZOOM,
} from "@/components/ui/Mapbox/config";
import type { RetailersRoute } from "@/data/routes/retailers.route";
import {
	RetailersMapLoader,
	RetailersMapLoaderSkeleton,
} from "@/features/retailers/components/RetailersMap";
import type { BlokRetailerListing } from "@/storyblok";

export interface RetailerListingProps
	extends BlokProps<BlokRetailerListing, RetailersRoute["list"]> {}

export const RetailerListing = ({ blok, data }: RetailerListingProps) => {
	const mapZoom = Number(blok.initialMapZoom) || MAPBOX_INITIAL_ZOOM;

	const mapCenter: [number, number] = [
		Number(blok.initialLon) || MAPBOX_INITIAL_CENTER[0],
		Number(blok.initialLat) || MAPBOX_INITIAL_CENTER[1],
	];

	return (
		<Container>
			<RetailersMapLoader
				retailers={data?.retailers?.map((r) => r.content) ?? []}
				mapZoom={mapZoom}
				mapCenter={mapCenter}
			/>
		</Container>
	);
};

export const RetailerListingSkeleton = () => {
	return (
		<Container>
			<RetailersMapLoaderSkeleton />
		</Container>
	);
};
